import React from 'react';
import { useTranslation } from 'i18n';
import { FormTextInput } from 'routes/auth/style';
import {
  PasswordHideIcon,
  PasswordShowIcon,
  PasswordRightIconContainer,
  PasswordRightIconText,
} from 'routes/auth/components/password/style';

interface PasswordProps {
  name: string;
  placeholder?: string;
  onKeyUp?: Function;
  onBlur?: Function;
}

/**
 * Password component with show/hide password functionality
 * @constructor
 */
export default function Password(props: PasswordProps) {
  const { t } = useTranslation();
  // either an `password` (hide) or `text` (show)
  const [isPasswordVisible, setPasswordVisible] = React.useState(false);

  const type = isPasswordVisible ? 'input' : 'password';

  const icon = isPasswordVisible ? <PasswordHideIcon /> : <PasswordShowIcon />;

  const label = isPasswordVisible ? t('hide') : t('show');

  return (
    <>
      <FormTextInput
        type={type}
        {...props}
        iconRight={() => {
          return (
            <PasswordRightIconContainer
              onClick={() => setPasswordVisible(!isPasswordVisible)}>
              {icon}
              <PasswordRightIconText>{label}</PasswordRightIconText>
            </PasswordRightIconContainer>
          );
        }}
      />
    </>
  );
}
